<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 游戏列表统一数据源:启动刷新(当前为 config mock,将来替换为后台接口)
    this.$store.dispatch('fetchGames')
  }
}
</script>

<style lang="less">
#app-root { height: 100%; }
</style>
